import { parse } from "query-string";
import { useLocation } from "react-router-dom";

export const useSearch = () => {
  const { search } = useLocation();
  return parse(search, { arrayFormat: "bracket" });
};
